/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomerCategoryGroup } from '../models/customer-category-group';
import { findAll8 } from '../fn/customer-category-group/find-all-8';
import { FindAll8$Params } from '../fn/customer-category-group/find-all-8';

@Injectable({ providedIn: 'root' })
export class CustomerCategoryGroupService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `findAll8()` */
  static readonly FindAll8Path = '/api/values/customer-category-group';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findAll8()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAll8$Response(params?: FindAll8$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CustomerCategoryGroup>>> {
    return findAll8(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findAll8$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAll8(params?: FindAll8$Params, context?: HttpContext): Observable<Array<CustomerCategoryGroup>> {
    return this.findAll8$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CustomerCategoryGroup>>): Array<CustomerCategoryGroup> => r.body)
    );
  }

}
